<template>
  <div class="icon rotate-45" v-html="Rotate45"></div>
</template>

<script>
import Rotate45 from './rotate-45.svg'
export default {
  data () {
    return {
      Rotate45: Rotate45
    }
  }
}
</script>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/Rotate45.vue